// eslint-disable-next-line no-restricted-imports
import { i18n } from '@lingui/core';
import { en, fr, es } from 'make-plural/plurals';
import { messages as enMessages } from 'locale/en/messages';
import { messages as frMessages } from 'locale/fr/messages';
import { messages as esMessages } from 'locale/es/messages';
import { SamplesLanguages } from 'types/enums';

i18n.loadLocaleData({
    [SamplesLanguages.EN]: { plurals: en },
    [SamplesLanguages.FR]: { plurals: fr },
    [SamplesLanguages.ES]: { plurals: es },
});

i18n.load(SamplesLanguages.EN, enMessages);
i18n.load(SamplesLanguages.FR, frMessages);
i18n.load(SamplesLanguages.ES, esMessages);

if (process.env.NODE_ENV === 'test') {
    i18n.activate(SamplesLanguages.EN);
}

export { i18n };
